export const FORM_FIELDS = {
    TEXT: "TEXT",
    DATE: "DATE",
    BOOL: "BOOL",
    TIME: "TIME",
    INT: "int",
    BIG_INT: "BIG_INT",
    TIMESTAMP: "TIMESTAMP",
    VARCHAR: "VARCHAR",
    DECIMAL: "DECIMAL",
    DOUBLE_PRECISION: "DOUBLE_PRECISION",
    INTERVAL: "INTERVAL",
    REAL: "REAL",
};

export const FORM_FIELD_DICTIONARY = {
    [FORM_FIELDS.TEXT]: "text",
    [FORM_FIELDS.DATE]: "date",
    [FORM_FIELDS.BOOL]: "bool",
    [FORM_FIELDS.TIME]: "time",
    [FORM_FIELDS.INT]: "int",
    [FORM_FIELDS.BIG_INT]: "bigint",
    [FORM_FIELDS.TIMESTAMP]: "timestamp",
    [FORM_FIELDS.VARCHAR]: "varchar",
    [FORM_FIELDS.DECIMAL]: "decimal",
    [FORM_FIELDS.DOUBLE_PRECISION]: "double precision",
    [FORM_FIELDS.INTERVAL]: "interval",
    [FORM_FIELDS.REAL]: "real",
};
